{
  "name": "tidy-homekeeping",
  "author": "Tidy Services Inc",
  "description": "TIDY: Cleaning and Maintenance Automation.",
  "homepage": "https://www.tidy.com",
  "private": true,
  "version": "1.91.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run lint:fix && ng build && npm run sentry:sourcemaps",
    "build:skip-lint": "ng build && npm run sentry:sourcemaps",
    "sandbox3": "npm run lint:fix && npx ionic serve --configuration=sandbox3",
    "sandbox3:no-lint": "npx ionic serve --configuration=sandbox3",
    "sandbox3:portless": "npm run lint:fix && portless run ng serve --configuration=sandbox3",
    "sandbox3:portless:no-lint": "portless run ng serve --configuration=sandbox3",
    "staging": "npm run lint:fix && npx ionic serve --configuration=staging",
    "staging:no-lint": "npx ionic serve --configuration=staging",
    "production": "npm run lint:fix && npx ionic serve --configuration=production",
    "production:no-lint": "npx ionic serve --configuration=production",
    "production:dev": "npx ionic serve --configuration=production_dev",
    "test": "vitest run --config vitest-base.config.ts",
    "css:analyze": "ngx-unused-css",
    "test:watch": "vitest --config vitest-base.config.ts",
    "test:coverage": "vitest run --coverage --config vitest-base.config.ts",
    "test:ui": "vitest --ui --config vitest-base.config.ts",
    "lint": "./lint-by-directory-with-errors.sh --fix",
    "lint:check": "./lint-by-directory-with-errors.sh",
    "lint:fix": "./lint-by-directory-with-errors.sh --fix",
    "lint:check:old": "./lint-by-directory.sh",
    "lint:ng": "ng lint",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:smoke": "playwright test smoke",
    "e2e:visual": "playwright test visual",
    "e2e:flows": "playwright test flows",
    "e2e:update-snapshots": "playwright test --update-snapshots",
    "e2e:report": "playwright show-report",
    "e2e:codegen": "playwright codegen http://localhost:8100",
    "e2e:native": "npm run e2e:native:setup && npm run e2e:native:build && npm run e2e:native:android",
    "e2e:native:setup": "bash e2e/wdio/scripts/setup-emulator-assets.sh",
    "e2e:native:build": "ionic build --configuration=sandbox3 && npx cap sync android",
    "e2e:native:android": "wdio e2e/wdio/config/wdio.native.conf.ts",
    "e2e:native:ios": "ionic build --configuration=sandbox3 && npx cap sync ios && wdio e2e/wdio/config/wdio.native.conf.ts",
    "test:capacitor": "bash e2e/wdio/scripts/run-capacitor-tests.sh android",
    "test:capacitor:ios": "bash e2e/wdio/scripts/run-capacitor-tests.sh ios",
    "bump": "npm version --no-git-tag-version",
    "capacitor-build": "chmod +x scripts/capacitor-build.sh && /bin/bash ./scripts/capacitor-build.sh",
    "build:android": "chmod +x scripts/build-android.sh && /bin/bash ./scripts/build-android.sh",
    "build:android:debug": "chmod +x scripts/build-android.sh && /bin/bash ./scripts/build-android.sh -- production debug",
    "build:android:clean": "chmod +x scripts/clean-and-build-android.sh && /bin/bash ./scripts/clean-and-build-android.sh",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org tidy-uy --project client-app www && sentry-cli sourcemaps upload --org tidy-uy --project client-app www",
    "analyze": "ng build --configuration=production_prod_mode && source-map-explorer www/browser/*.js",
    "analyze:html": "ng build --configuration=production_prod_mode && source-map-explorer www/browser/*.js --html analyze-report.html",
    "capacitor-build-strip-bitcode": "chmod +x scripts/strip-bitcode.sh && /bin/bash ./scripts/strip-bitcode.sh",
    "prepare": "husky",
    "validate-translations": "node scripts/validate-translations.js",
    "add-translate-pipes": "node scripts/add-translate-pipes.js",
    "add-translate-pipes:dry-run": "node scripts/add-translate-pipes.js --dry-run",
    "auto-translate": "node scripts/auto-translate.js",
    "auto-translate:dry-run": "node scripts/auto-translate.js --dry-run",
    "postinstall": "mkdir -p src/assets/usdz-wasm && cp -r node_modules/three-usdz-loader/external/* src/assets/usdz-wasm/"
  },
  "config": {
    "ionic_cleancss": "./scripts/cleancss.config.js"
  },
  "dependencies": {
    "@angular/animations": "21.1.0",
    "@angular/cdk": "21.1.0",
    "@angular/common": "21.1.0",
    "@angular/compiler": "21.1.0",
    "@angular/core": "21.1.0",
    "@angular/forms": "21.1.0",
    "@angular/material": "21.1.0",
    "@angular/platform-browser": "21.1.0",
    "@angular/platform-browser-dynamic": "21.1.0",
    "@angular/router": "21.1.0",
    "@aws-sdk/client-s3": "3.886.0",
    "@capacitor-community/exif": "7.0.0",
    "@capacitor-community/video-recorder": "7.5.0",
    "@capacitor/android": "7.0.0",
    "@capacitor/app": "7.0.0",
    "@capacitor/app-launcher": "7.0.4",
    "@capacitor/browser": "7.0.0",
    "@capacitor/camera": "7.0.0",
    "@capacitor/core": "7.0.0",
    "@capacitor/geolocation": "7.0.0",
    "@capacitor/ios": "7.0.0",
    "@capacitor/keyboard": "7.0.0",
    "@capacitor/splash-screen": "7.0.0",
    "@capawesome/capacitor-app-review": "7.0.1",
    "@capawesome/capacitor-file-picker": "7.0.0",
    "@capawesome/capacitor-posthog": "^7.4.0",
    "@capgo/capacitor-social-login": "^7.20.0",
    "@fontsource/dancing-script": "5.1.1",
    "@fontsource/inter": "5.1.1",
    "@google/genai": "^1.50.1",
    "@ionic/angular": "8.7.3",
    "@ionic/angular-toolkit": "12.3.0",
    "@ionic/core": "8.7.3",
    "@ionic/storage": "4.0.0",
    "@ionic/storage-angular": "4.0.0",
    "@recogito/annotorious": "2.7.6",
    "@sentry/angular": "10.34.0",
    "@sentry/cli": "2.42.2",
    "@tanstack/angular-query-experimental": "5.90.23",
    "@types/dom-mediacapture-record": "1.0.10",
    "angular-imask": "7.6.1",
    "apexcharts": "5.3.5",
    "bowser": "2.12.1",
    "canvas-confetti": "1.9.2",
    "config-xml-version": "^0.0.2",
    "exifr": "7.1.3",
    "intl-tel-input": "25.3.1",
    "ionic-version": "^1.0.3",
    "ionicons": "8.0.13",
    "json-formatter-js": "2.3.4",
    "json-to-csv-export": "3.1.2",
    "luxon": "3.7.2",
    "ng-in-viewport": "16.1.0",
    "ng-recaptcha": "13.2.1",
    "ngx-color-picker": "20.1.1",
    "ngx-cookie": "6.0.1",
    "ngx-mat-select-search": "7.0.10",
    "onesignal-cordova-plugin": "5.2.15",
    "posthog-js": "^1.356.1",
    "querystring-es3": "0.2.1",
    "rxjs": "7.8.2",
    "signature_pad": "^5.1.3",
    "supercluster": "^8.0.1",
    "swiper": "12.0.1",
    "three": "^0.182.0",
    "three-usdz-loader": "^1.0.9",
    "tslib": "2.4.0",
    "ulid": "3.0.1",
    "uuid": "13.0.0",
    "zone.js": "0.15.1"
  },
  "overrides": {
    "ng-recaptcha": {
      "@angular/core": "21.1.0"
    },
    "ngx-mat-select-search": {
      "@angular/material": "21.1.0",
      "@angular/core": "21.1.0"
    },
    "eslint-plugin-rxjs": {
      "eslint": "9.35.0"
    },
    "@typescript-eslint/experimental-utils": {
      "eslint": "9.35.0"
    },
    "eslint-etc": {
      "eslint": "9.35.0"
    },
    "three-usdz-loader": {
      "three": "0.182.0"
    }
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.2.2",
    "@analogjs/vitest-angular": "^2.2.2",
    "@angular-builders/custom-webpack": "21.0.3",
    "@angular-devkit/architect": "0.2101.0",
    "@angular-devkit/build-angular": "21.1.0",
    "@angular-devkit/core": "21.1.0",
    "@angular-devkit/schematics": "21.1.0",
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/build": "^21.1.0",
    "@angular/cli": "21.1.0",
    "@angular/compiler-cli": "21.1.0",
    "@capacitor/cli": "7.0.0",
    "@colors/colors": "^1.6.0",
    "@ionic/cli": "7.2.1",
    "@playwright/test": "^1.56.1",
    "@types/jest": "30.0.0",
    "@types/luxon": "3.7.1",
    "@types/node": "24.4.0",
    "@types/supercluster": "^7.1.3",
    "@types/three": "^0.182.0",
    "@typescript-eslint/eslint-plugin": "8.44.0",
    "@typescript-eslint/parser": "8.44.0",
    "@vitest/ui": "^4.0.17",
    "@wdio/appium-service": "^9.20.0",
    "@wdio/browserstack-service": "^9.20.0",
    "@wdio/cli": "^9.20.0",
    "@wdio/globals": "^9.17.0",
    "@wdio/local-runner": "^9.20.0",
    "@wdio/mocha-framework": "^9.20.0",
    "@wdio/spec-reporter": "^9.20.0",
    "@wizbii/ngx-unused-css": "^4.0.2",
    "appium": "^3.0.2",
    "appium-uiautomator2-driver": "^5.0.4",
    "appium-xcuitest-driver": "^10.1.4",
    "chromedriver": "^140.0.4",
    "dotenv": "^17.2.3",
    "eslint": "9.35.0",
    "eslint-plugin-rxjs": "5.0.3",
    "expect-webdriverio": "^5.4.3",
    "husky": "9.1.7",
    "jsdom": "^27.4.0",
    "portless": "^0.13.0",
    "puppeteer-core": "^24.36.1",
    "purgecss": "^7.0.2",
    "source-map-explorer": "^2.5.3",
    "ts-node": "10.9.2",
    "typescript": "5.9.2",
    "vitest": "^4.0.17",
    "webpack": "5.101.3"
  },
  "lint-staged": {
    "*.ts": [
      "eslint --max-warnings=0"
    ],
    "*.html": [
      "eslint --max-warnings=0"
    ]
  }
}
